import { getUserGroups } from './getUserGroups';
import { LoginType } from '../../api-types/models/LoginDto';
import type { SerializableAuthUser } from '../../interfaces/authUser';

export function isBrunchUser(user: SerializableAuthUser | null | undefined) {
    if (!user) {
        return false;
    }

    return getUserGroups(user).includes(LoginType.BRUNCH);
}
